<template>
  <div id="page-loader" class="show"></div>
</template>

<script>
export default {
  name: 'Loader'
}
</script>
